module.exports = __webpack_public_path__ + "media/images/lb/682-d3101fa6e583c53a8808c3310f813a18.svg";